import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component:  () => import('@/views/Home.vue'),
    },
    {
        path: '/product',
        name: 'product',
        component: () => import('@/views/product/index.vue'),
    },
    {
        path: '/product/detail',
        name: 'productDetail',
        component: () => import('@/views/product/Detail.vue'),
    },
    {
        path: '/project',
        name: 'project',
        component: () => import('@/views/project/index.vue'),
    },
    {
        path: '/news',
        name: 'news',
        component: () => import('@/views/news/index.vue'),
    },
    {
        path: '/news/detail',
        name: 'newsDetail',
        component: () => import('@/views/news/Detail.vue'),
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('@/views/about/index.vue'),
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import('@/views/contact/index.vue'),
    },
    {
        path: '/msg-board',
        name: 'msgBoard',
        component: () => import('@/views/contact/MessageBoard.vue'),
    },
];

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
});

export default router;
